import { IState } from 'shared/store';

export function selectReviewGoToAppModalOpen(state: IState) {
  return state.reviewsGoToAppModal.isOpen;
}
